/**
 * React Query hook for application-level branding (logo, app_name).
 * No access key required. Works both pre-auth (sign-in/sign-up) and
 * post-auth (app shell), independent of the public index page's state.
 */

import { useQuery } from '@tanstack/react-query';
import APIHelper from '../api/APIHelper';
import envConfig from '../config/envConfig';

const apiHelper = new APIHelper({
  apiUrl: envConfig.backendApiUrl,
  tokenUrl: envConfig.backendTokenUrl,
  clientId: envConfig.clientKey,
  clientSecret: envConfig.clientSecret,
});

export function useAppBranding() {
  const path = `/arcee/public/${envConfig.organizationId}/${envConfig.applicationId}/branding/`;

  return useQuery({
    queryKey: ['app-branding', envConfig.organizationId, envConfig.applicationId],
    queryFn: async () => {
      const resp = await apiHelper.publicApiCall(path, { method: 'GET', cache: 'no-cache' });
      if (!resp.ok) {
        const err = new Error('Failed to load app branding');
        err.status = resp.status;
        throw err;
      }
      return resp.json();
    },
    staleTime: Infinity,
    retry: false,
  });
}
